const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/marketing_emails/unsubscribe.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const unsubscribeSearchSchema = z.object({
  token: z.string().optional().catch(undefined)
});
export const Route = createFileRoute("/marketing_emails/unsubscribe")({
  validateSearch: unsubscribeSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});